import React from "react";
import { Route, Redirect } from "react-router-dom";

import isLogin from '../src/components/lib/isLogin';


const ConditionRoute = ({ component: Component, layout: Layout, auth, type, ...rest }) => {
    // console.log(Component,Layout,"Component")
    return (

        <Route
            {...rest}
            render={props => {
                // console.log("ConditionRoute",type ,type == 'auth' && isLogin() == true, type == 'private' && isLogin() != true)
                if (type == 'auth' && isLogin() == true) {

                    return <Redirect to="/straight-bet" />
                } else if (type == 'private' && isLogin() != true) {
                    return <Redirect to="/login" />
                }
                return <Component {...props} />
            }}
        />
    )

};

export default ConditionRoute;